// ============================================================
// BELLO PAPER — SITE CONFIGURATION
// Edit the values below to update links across the whole site.
// Every button, form and footer link reads from this file.
// ============================================================

export const BRAND_NAME = "Bello Paper";

// ------------------------------------------------------------
// BOOKING LINK — "Book a call with the founder"
// ⬇ CHANGE HERE: paste your Google Calendar / Cal.com link.
// Until a real https link is added, booking buttons show a
// friendly "link not added yet" note instead of a broken page.
// ------------------------------------------------------------
export const BOOKING_URL = "https://calendly.com/meghana-bellopaper/30min";

// ------------------------------------------------------------
// EMAIL SIGNUP — "Keep me posted"
// ⬇ CHANGE HERE: paste your email platform endpoint
// (Mailchimp / ConvertKit / Buttondown / your own API).
// The form POSTs JSON: { email: "person@example.com" }
// Until an endpoint is added, the form runs in DEV MODE:
// it validates the email and shows the success state, but
// nothing is sent anywhere yet.
// ------------------------------------------------------------
export const EMAIL_SIGNUP_ENDPOINT = "[ADD EMAIL PLATFORM ENDPOINT HERE]";

// ------------------------------------------------------------
// SOCIAL LINKS — footer
// ⬇ CHANGE HERE
// ------------------------------------------------------------
export const INSTAGRAM_URL = "https://www.instagram.com/meg_in_progress/";
export const LINKEDIN_URL = "https://www.linkedin.com/in/meghana-kuppinakere-mutt/";
export const CONTACT_EMAIL = "meghana@bellopaper.com";

// ------------------------------------------------------------
// LOGO — file lives in /public
// ⬇ CHANGE HERE if you ever replace the logo file
// ------------------------------------------------------------
export const LOGO_SRC = "/bello-logo.webp";

// Dark-background version of the logo — use ONLY on navy backgrounds (footer).
export const LOGO_DARK_SRC = "/bello-logo-dark.webp";

// ------------------------------------------------------------
// FOUNDER IMAGE
// ⬇ CHANGE HERE: drop a photo into /public (e.g. /meghana.jpg)
// and set FOUNDER_IMAGE to "/meghana.jpg".
// Leave as null to use the built-in illustrated placeholder.
// ------------------------------------------------------------
export const FOUNDER_IMAGE = "/meghana.webp";

// Helper — true only when a real https link has been pasted in.
export const isLiveUrl = (url) => typeof url === "string" && url.startsWith("http");
